import ActionButton from '@westwing/ui-kit/ActionButton';
import styled from 'styled-components';

export const MagicLinkButton = styled(ActionButton)`
    font-size: 0.875em;
    line-height: 1;
    cursor: pointer;
    margin: 8px 0 0;

    &:disabled {
        cursor: default;
    }
`;
